import ReactFlow, {
  Background,
  ConnectionMode,
  MarkerType,
  ReactFlowProvider,
  getNodesBounds,
  useEdgesState,
  useNodesState,
} from "reactflow";

import ZoomFlow from "../../../../../componentes/easyMaps/ZoomFlow";
import { Box, lighten, Stack, useMediaQuery, useTheme } from "@mui/material";
import ElementNode from "../../../../../componentes/easyMaps/elementNode";
import PositionableEdge from "../../../../../componentes/easyMaps/positionableEdge";
import { useEffect, useMemo, useRef, useState } from "react";

import FilterElements from "../../../../../componentes/easyMaps/filterElements";
import TitleBarPublic from "../../../../../componentes/easyMaps/titleBarPublic";
import DescriptionBar from "../../../../../componentes/easyMaps/descriptionBar";
import RightBarEasyMaps from "../../../../../componentes/easyMaps/rightBarEasyMaps";
import { useOutletContext, useParams } from "react-router-dom";
import ToolBarMapsPublic from "../../../../../componentes/easyMaps/toolbarMapsPublic";
import LayerBar from "../../../../../componentes/easyMaps/layerBar";
import { useMapa } from "../../../../../contexts/mapaContext";
const nodeTypes = {
  element: ElementNode,
};
const edgeTypes = {
  positionableedge: PositionableEdge,
};
const ReactFlowMapas = (props) => {
  const {
    setEdgeSelected,
    setElementsConnected,
    iconsElements,
    setOpenRightBar,
    focusNodeId,
    fullScreem,
    setFullScreem,
    title,
    setCoordenadasFlow = () => {},
    setIconsElements,
    edgeSelected,
    openRightBar,
    setFocusNodeId,
    setEasyMapsConfig = () => {},
    easyMapsConfig,
    collapse,
  } = props;
  const {
    mapId,
    elements,
    connections,
    connectionsDataMap,
    elementSelected,
    setElementSelected,
    connectionSelected,
    setConnectionSelected,
    configElementDataMap,
    setSnackbar,
    configurationMap,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
    alertsDataMap,
  } = useMapa();
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const bounds = getNodesBounds(nodes);
  const [lockMode, setLockMode] = useState(false);
  const [showLabel, setShowLabel] = useState(true);
  const [elementsFilter, setElementsFilter] = useState([]);
  const [openConnection, setOpenConnection] = useState(null);
  const [showLabelEnlace, setShowLabelEnlace] = useState(true);
  // pega os elementos e conexões do Map
  const elementsFromMap = useMemo(() => [...elements?.values()], [elements]);
  const connectionsFromMap = useMemo(
    () => [...connections?.values()],
    [connections]
  );
  const ref = useRef();
  const { id, token } = useParams();
  const { configLayer } = useOutletContext();
  const theme = useTheme();

  const styles = {
    stackContainer: {
      position: fullScreem ? "fixed" : "relative",
      top: 0,
      left: 0,
      width: fullScreem ? "100vw" : "100%",
      height: fullScreem ? "100vh" : "100%",
      zIndex: fullScreem ? 1202 : 0,
      background:
        theme.palette.mode == "dark"
          ? theme.palette.background.default
          : lighten(theme.palette.background.default, 0.6),
      overflow: "visible",
    },
  };

  const filteredData = useMemo(() => {
    if (!configurationMap || !configLayer) {
      return { nodes: elementsFromMap, edges: connectionsFromMap };
    }
    const isPotencia = configLayer?.[mapId] === "potencia";
    const filtros =
      configurationMap?.configuracoes?.[
        isPotencia ? "camadaPotencia" : "camadaTrafego"
      ]?.filtros;
    if (!filtros || filtros.length === 0) {
      return { nodes: elementsFromMap, edges: connectionsFromMap };
    }

    const dataMap = isPotencia
      ? connectionsDataMapPercentPower
      : connectionsDataMapPercentTraffic;

    // Gera um Set com todos os IDs de conexões filtradas (evita includes O(n))
    const enlacesSelected = new Set(
      filtros?.flatMap((label) => dataMap.get(label) || [])
    );
    //filtras as conexões com base nos filtros
    const enlacesFiltered = connectionsFromMap.filter((conn) =>
      enlacesSelected.has(conn.id)
    );

    // Filtra conexões relevantes e extrai IDs únicos de markers
    const markersSelectedId = new Set(
      connectionsFromMap?.flatMap((conn) =>
        enlacesSelected.has(conn.id)
          ? [conn.destinationId, conn.referenceId]
          : []
      )
    );
    // Retorna apenas markers com ID presente
    const filtered = elementsFromMap.filter((m) => markersSelectedId.has(m.id));

    return { nodes: filtered, edges: enlacesFiltered };
  }, [
    configurationMap,
    configLayer,
    mapId,
    elementsFromMap,
    connectionsFromMap,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
  ]);

  useEffect(() => {
    setCoordenadasFlow({
      x: bounds?.x + bounds?.width / 2,
      y: bounds?.y + bounds?.height / 2,
    });
  }, [nodes]);

  useEffect(() => {
    setConnectionSelected(null);
    //setOpenConnection(null);
    setElementsConnected(null);
    setNodes(
      handleFormaterNodes(structuredClone(filteredData?.nodes), showLabel)
    );
    setEdges(
      handleFormaterEdges(structuredClone(filteredData?.edges), showLabel)
    );
  }, [
    configLayer,
    showLabel,
    showLabelEnlace,
    elementsFilter,
    configurationMap,
  ]);

  useEffect(() => {
    if (!filteredData?.nodes && !filteredData?.edges) return;

    let formaterElements = structuredClone(filteredData?.nodes);
    if (elementSelected) {
      formaterElements = [
        ...filteredData?.nodes.filter((ele) => ele?.id !== elementSelected?.id),
        elementSelected,
      ];
    }
    let formaterConnections = structuredClone(filteredData?.edges);
    if (connectionSelected) {
      formaterConnections = [
        ...filteredData?.edges.filter(
          (conn) => conn?.id !== connectionSelected?.id
        ),
        {
          ...connectionSelected,
          positionHandlers: edgeSelected?.data?.positionHandlers,
        },
      ];
    }
    setNodes(handleFormaterNodes(formaterElements, showLabel));
    setEdges(handleFormaterEdges(formaterConnections, showLabel));
  }, [filteredData?.nodes, filteredData?.edges, connectionsDataMap]);

  //-----funcoes para formatação de dados
  const handleFormaterNodes = (
    elements,
    showLabel = true,
    entangled = true,
    selected = false
  ) => {
    const filter = elementsFilter.map((value) => value.tipo);
    const newElements =
      elementsFilter.length > 0
        ? elements.filter(({ tipo }) => filter.includes(tipo))
        : elements;

    const result = newElements.map(
      ({ id, elementConfig, titulo, alerts, img, tipo }) => {
        return {
          id,
          type: "element",
          draggable: elementSelected && elementSelected?.id == id,
          position: {
            x: parseFloat(elementConfig?.config?.coordenadas?.long),
            y: parseFloat(elementConfig?.config?.coordenadas?.lat),
          },
          selected: elementSelected?.id === id ? true : false,
          data: {
            configElement: configElementDataMap.get(id),
            img:
              iconsElements?.find((icon) => icon.id == img)?.img ||
              iconsElements?.find(
                (icon) =>
                  icon.nome ==
                  (tipo === 0 ? "_roteador" : tipo === 1 ? "_mapa" : "_pop")
              )?.img,

            editMode: false,
            showLabel,
            entangled,
            title: titulo,
            hosts: elementConfig?.config?.hosts,
            tipoMapa: 1,
            alerts: alertsDataMap.get(id) || [],
            easyMapsConfig: structuredClone(configurationMap),
            value: 123,
          },
        };
      }
    );
    return result;
  };
  const handleFormaterEdges = (
    conections,
    showLabel = true,
    entangled = true
  ) => {
    const result = conections.map(
      ({ id, referenceId, destinationId, positionHandlers, config, data }) => {
        const dataConn = structuredClone(connectionsDataMap.get(id));
        return {
          id,
          source: referenceId,
          type: "positionableedge",
          animation: true,
          sourceHandle: config?.sourceHandle,
          targetHandle: config?.targetHandle,
          target: destinationId,
          animated: config?.animation !== "desativada" && !dataConn?.isDown,
          updatable: "target",
          markerEnd: "",
          labelStyle: { fill: "#26721f", fontWeight: 700 },
          selected: connectionSelected?.id === id ? true : false,
          data: {
            ...dataConn,
            host: elements?.get(referenceId)?.titulo,
            mapId: mapId,
            itensData: data,
            showLabel,
            variant: configLayer?.[mapId] || "trafego",
            showLabelEnlace,
            entangled,
            lineType: config?.type,
            capacidade: config?.capacidade,
            positionHandlers: structuredClone(positionHandlers ?? []),
            //perigo eminente, sob hipótese nenhuma mexa nessa linha de código!
            label: "999.99Mbps",
            animation: config?.animation,
            easyMapsConfig: structuredClone(configurationMap),
            configLine: config,
          },
        };
      }
    );
    return result;
  };

  const updateMemberStatus = (elements, ids, updateData) => {
    return elements.map((element) => ({
      ...element,
      data: {
        ...element.data,
        ...updateData(ids.includes(element.id)),
      },
    }));
  };

  const onNodeClick = (event, node) => {
    setConnectionSelected(null);
    setOpenConnection(null);
    setEdgeSelected(null);
    const selected = structuredClone(elements?.get(node.id));
    if (selected?.id === elementSelected?.id) {
      setElementSelected(null);
      return;
    }
    setElementSelected(selected);

    let idsElements = [selected.id];
    let idsConnections = [];
    let elementsConnect = [];

    filteredData?.edges.forEach(({ referenceId, destinationId, id }) => {
      if (node.id === destinationId || node?.id === referenceId) {
        const findElement = elements?.get(
          node.id === destinationId ? referenceId : destinationId
        );
        elementsConnect.push(findElement);
        idsElements.push(findElement?.id);
        idsConnections.push(id);
      }
    });
    setElementsConnected(elementsConnect);

    const updateEntangled = (isEntangled) => ({ entangled: isEntangled });

    setNodes((nds) => updateMemberStatus(nds, idsElements, updateEntangled));
    setEdges((eds) => updateMemberStatus(eds, idsConnections, updateEntangled));
    setOpenRightBar(true);
    return;
  };

  const onEdgeClick = (event, edge) => {
    setElementSelected(null);
    const selected = connections?.get(edge.id);
    setConnectionSelected(selected);
    setElementSelected(elements?.get(selected?.referenceId));
    setOpenConnection(selected?.id);
  };

  const onPaneClick = (e) => {
    setConnectionSelected(null);
    setOpenConnection(null);
    setEdgeSelected(null);
    setNodes(handleFormaterNodes(filteredData?.nodes, showLabel));
    setEdges(handleFormaterEdges(filteredData?.edges, showLabel));
    setElementsConnected(null);

    if (elementSelected || edgeSelected) {
      setEdgeSelected(null);
      setConnectionSelected(null);
      setElementSelected(null);
    }
  };

  return (
    <>
      <Box sx={{ overflow: "visible", zIndex: 1203 }}>
        <TitleBarPublic
          title={title}
          center={elementSelected != null || connectionSelected != null}
        />
      </Box>
      <Stack sx={styles.stackContainer}>
        <ReactFlowProvider>
          <ToolBarMapsPublic
            setEasyMapsConfig={setEasyMapsConfig}
            easyMapsConfig={structuredClone(easyMapsConfig)}
            fullScreem={fullScreem}
            setFullScreem={setFullScreem}
            showLabel={showLabel}
            setShowLabel={setShowLabel}
            setShowLabelEnlace={setShowLabelEnlace}
            showLabelEnlace={showLabelEnlace}
            tipo={1}
          >
            <ToolBarMapsPublic.InputZoomTop />
          </ToolBarMapsPublic>
          <LayerBar elementSelected={elementSelected} mapId={mapId} />
          <DescriptionBar
            elementSelected={!!elementSelected}
            key={"descrptionbar"}
            variant="default"
            layer={configLayer?.[mapId] || "trafego"}
          />
          <FilterElements
            iconsElement={iconsElements}
            elementsFilter={elementsFilter}
            setElementsFilter={setElementsFilter}
          />
          <ZoomFlow
            id={id}
            focusNodeId={focusNodeId}
            setFocusNodeId={setFocusNodeId}
          />
          <ReactFlow
            ref={ref}
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            snapToGrid={false}
            onPaneClick={onPaneClick}
            elementsSelectable={!lockMode}
            nodesConnectable={false}
            nodesDraggable={false}
            attributionPosition="bottom-left"
            fitView
            connectionMode={ConnectionMode.Loose}
            onNodeClick={onNodeClick}
            onEdgeClick={onEdgeClick}
            minZoom={0.5}
            maxZoom={3}
            proOptions={{ hideAttribution: true }}
          >
            <Background />
          </ReactFlow>{" "}
          <RightBarEasyMaps
            mapId={mapId}
            setIconsElements={setIconsElements}
            connectionsFull={connections}
            setFocusNodeId={setFocusNodeId}
            open={openRightBar}
            setOpen={setOpenRightBar}
            elements={elements}
            connections={connections}
            setElement={setElementSelected}
            setConnections={setElementsConnected}
            iconsElement={iconsElements}
            element={elementSelected?.id ? elementSelected : null}
            fullScreem={fullScreem}
            openConnection={openConnection}
            setOpenConnection={setOpenConnection}
            link={`/easyMaps/mapa/public/${
              elementSelected?.mapRef?.tipo === 0 ? "geo" : "top"
            }/${elementSelected?.mapRefId ?? ""}/${token}`}
          />
        </ReactFlowProvider>{" "}
      </Stack>{" "}
    </>
  );
};
export default ReactFlowMapas;
